import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../services/api";

import "../styles/categorySection.css";

function CategorySection() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await api.get("/categories");
      setCategories(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <section className="categories-section">

      <div className="section-header">

        <h2>Browse Categories</h2>

        <p>
          Choose a category and discover
          available examination papers.
        </p>

      </div>

      <div className="categories-grid">

        {categories.map((category) => (

          <div
            className="category-card"
            key={category.id}
          >

            <h3>{category.name}</h3>

            <p>
              {category.description ||
                "No description available."}
            </p>

            <Link
              to={"/categories"}
              className="browse-btn"
            >
              Browse Exams
            </Link>

          </div>

        ))}

      </div>

    </section>
  );
}

export default CategorySection;
